import React, { useEffect, useState } from "react";
import styles from "./GalleryDetails.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { SubmitButton, TextComponent } from "../../../../../components";
import share from "../../../../../assets/share.png";
import upload from "../../../../../assets/download.png";
import { Carousel, List, Row } from "antd";
import CopyLinkModal from "../../../../../components/copyLinkModal/CopyLinkModal";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { PhotosMiddleware } from "../../../../../Store/Middlewares/PhotosMiddleware";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { saveAs } from "file-saver";
import { LuDownload } from "react-icons/lu";

const GalleryDetails = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { state } = useLocation();
  const AlbumData = useSelector((state) => state.PhotosReducer.Album);
  const AlbumPagination = useSelector(
    (state) => state.PhotosReducer.AlbumPagination
  );
  // console.log("AlbumData", AlbumData?.[0]);

  const navigation = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    getAlbumData();
  }, []);

  const getAlbumData = () => {
    let data = {
      event_id: state?.item?.event_id,
      user_id: state?.item?.user_id,
      next_page_url: undefined,
    };
    dispatch(PhotosMiddleware.getAlbumPhotos(data));
  };
  const onPressRenderMoreContent = () => {
    let data = {
      event_id: state?.item?.event_id,
      user_id: state?.item?.user_id,
      next_page_url: AlbumPagination?.links?.next,
    };
    dispatch(PhotosMiddleware.getAlbumPhotos(data));
  };
  const renderImages = (item, index) => {
    if (item?.type == "video") {
      return (
        <div key={index} className={styles.listItem}>
          <div className={styles.square}>
            <video className={styles.video} controls>
              <source src={item?.attachments?.files} />
            </video>
          </div>
        </div>
      );
    } else {
      return (
        <div
          key={index}
          className={styles.listItem}
          onClick={() =>
            navigation("/events/singleImage", {
              state: { headrTitle: "Gallery", item: item },
            })
          }
        >
          <div className={styles.square}>
            <img src={item?.attachments?.files} className={styles.listImg} />
          </div>
        </div>
      );
    }
  };
  return (
    <div className={styles.mainCon}>
      <div className={styles.head}>
        <div className={styles.headLeft}>
          <TextComponent text={"Uploaded By:"} textClass={styles.uploadTxt} />
          <TextComponent
            text={state?.item?.user_name}
            textClass={styles.nameTxt}
          />
          <TextComponent
            text={moment(state?.item?.attachments?.created_at).format(
              "D MMM YYYY"
            )}
            textClass={styles.dateTxt}
          />
          {/* </div> */}
        </div>
        <div className={styles.headRight}>
          {/* <div className={styles.imageDiv} onClick={() => setModalOpen(true)}>
            <img src={share} className={styles.image} />
          </div> */}
          {/* <div
            className={styles.editImageDiv}
            onClick={() =>
              navigation("/events/uploadGallery", {
                state: { headrTitle: "Gallery" },
              })
            }
          >
            <img src={upload} className={styles.editImage} />
          </div> */}
        </div>
      </div>

      <Carousel
        className={`${styles.Carousel} caroselOverride`}
        // autoplay
        dots={{ className: "dotsCarosel" }}
        nextArrow={<BsChevronRight size={40} color="var(--primary-color)" />}
        prevArrow={<BsChevronLeft size={40} color="var(--primary-color)" />}
        arrows
        infinite={true}
      >
        {AlbumData?.[0]?.attachments?.map((item, i) => {
          if (item?.type == "video") {
            return (
              // <div key={index} className={styles.listItem}>
              //   <div className={styles.square}>
              <>
                <Row className={styles.iconRow}>
                  <div
                    className={styles.iconBtn}
                    onClick={() =>
                      // downloadImage(item?.files, `${filename}`)
                      saveAs(item?.files, `${item?.title ? item?.title: ''}`)
                    }
                  >
                    <LuDownload className={styles.icon} />
                  </div>
                </Row>
                <video className={styles.imageCont} controls>
                  <source src={item?.files} />
                </video>
              </>

              //   </div>
              // </div>
            );
          } else {
            return (
              <>
                <Row className={styles.iconRow}>
                  <div
                    className={styles.iconBtn}
                    onClick={() => saveAs(item?.files, `${item?.title ? item?.title: ''}`)}
                  >
                    <LuDownload className={styles.icon} />
                  </div>
                </Row>
                <div className={styles.imageCont}>
                  <img src={item?.files} className={styles.image} />
                </div>
              </>
            );
          }

          // <div className={styles.imgDiv}>
          //   <img src={item?.files} className={styles.image} />
          // </div>
          // <IGImageDetails
          //   key={item.id}
          //   item={item}
          //   setDeleteImgModal={setDeleteImgModal}
          //   setDeleteId={setDeleteId}
          // />
        })}
      </Carousel>

      {/* <List
        className={styles.list}
        grid={{ gutter: 16 }}
        itemLayout="horizontal"
        dataSource={AlbumData}
        renderItem={renderImages}
        footer={
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {AlbumPagination?.links?.next != null ? (
              <div style={{ width: "50%" }}>
                <SubmitButton
                  title={"Load More"}
                  onClick={onPressRenderMoreContent}
                />
              </div>
            ) : null}
          </div>
        }
      /> */}
      {/* <CopyLinkModal
        isCopyModalOpen={modalOpen}
        setIsCopyModalOpen={setModalOpen}
        link="https://www.bestdayever.com/invite"
      /> */}
    </div>
  );
};

export default GalleryDetails;
